import React from "react";
import { Grid, Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SecureLS from "secure-ls";
import Restaurant from "@mui/icons-material/Restaurant";
import PointOfSale from "@mui/icons-material/PointOfSale";
import ShoppingBag from "@mui/icons-material/ShoppingBag";
import ViewsHero from "./ViewsHero";
import TitleSetter from "../../component/TitleSetter";

const ls = new SecureLS({ encodingType: "aes" });

const ViewCard = ({ title, onClick, icon: Icon }) => {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      sx={{
        width: "100%",
        padding: 4,
        textAlign: "center",
        color: "#fff",
        backgroundColor: "#3f51b5",
        "&:hover": {
          backgroundColor: "#303f9f",
        },
        height: "100%",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          padding: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <Icon sx={{ fontSize: 60, marginBottom: 2 }} />
        <Typography variant="h6">{title}</Typography>
      </Paper>
    </Button>
  );
};

const Views = () => {
  const navigate = useNavigate();
  const user = ls.get("user");
  const posId = user?.posId;

  let manualCashierPath = `/${posId}`;
  if (posId === "672312ec5b53fbbe37d4b0d5") {
    manualCashierPath = "/test";
  } else if (posId === "67d3a2144a266ea37ce7ac69") {
    manualCashierPath = "/khiang";
  } else if (posId === "680e35b78a5a51ec452b6678") {
    manualCashierPath = "/khiangmpob";
  }

  const viewModules = [
    { title: "Kitchen View", path: "/views/kitchen", icon: Restaurant },
    { title: "Front of Desk View", path: "/views/front", icon: PointOfSale },
    // { title: "Assisted Mode", path: manualCashierPath, icon: ShoppingBag },
  ];

  return (
    <Box sx={{ flexGrow: 1, padding: 3 }}>
      <TitleSetter title="KDS Views" />
      <ViewsHero />
      <Grid container spacing={3} justifyContent="center" alignItems="stretch">
        {viewModules.map((view) => (
          <Grid
            key={view.title}
            item
            xs={12}
            sm={6}
            md={4}
            sx={{ display: "flex" }}
          >
            <ViewCard
              title={view.title}
              icon={view.icon}
              onClick={() => navigate(view.path)}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Views;
